import { type ReactElement } from 'react'
import { FileTextIcon, FilmIcon, ImageIcon } from 'lucide-react'

export type MimeTypeConfig = {
  icon: ReactElement
  type: string
}

export const MIME_TYPE_CONFIG: Record<string, MimeTypeConfig> = {
  // Video types
  'video/mp4': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/avi': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/mov': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/wmv': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/flv': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/mpeg': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/m4v': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/webm': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  'video/quicktime': { icon: <FilmIcon className="size-4" />, type: 'Video' },
  // Document types
  'application/pdf': { icon: <FileTextIcon className="size-4" />, type: 'PDF' },
  'application/msword': {
    icon: <FileTextIcon className="size-4" />,
    type: 'Word',
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    icon: <FileTextIcon className="size-4" />,
    type: 'Word',
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    icon: <FileTextIcon className="size-4" />,
    type: 'Excel',
  },
  'application/vnd.ms-excel': {
    icon: <FileTextIcon className="size-4" />,
    type: 'Excel',
  },
  'application/vnd.ms-powerpoint': {
    icon: <FileTextIcon className="size-4" />,
    type: 'PowerPoint',
  },
  'application/vnd.ms-word': {
    icon: <FileTextIcon className="size-4" />,
    type: 'Word',
  },
  'text/plain': { icon: <FileTextIcon className="size-4" />, type: 'Text' },
  'image/png': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/jpeg': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/jpg': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/gif': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/webp': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/svg': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/tiff': { icon: <ImageIcon className="size-4" />, type: 'Image' },
  'image/bmp': { icon: <ImageIcon className="size-4" />, type: 'Image' },
}
